<template>
  <div class="pt-15">
    <MattrzBaseLogo width="350" />
    <div class="pa-4 mx-auto my-5" style="width: 400px;">
      <NewResetPasswordContainer />
      <router-link class="d-inline-block mt-5" to="/user_auths/sign_in">
        ログインする
      </router-link>
    </div>
  </div>
</template>
<script>
import NewResetPasswordContainer from '/src/container/pages/NewResetPasswordContainer'
import MattrzBaseLogo from '/src/components/uiParts/images/MattrzBaseLogo'

export default {
  name: 'passwordReset',
  components: {
    NewResetPasswordContainer,
    MattrzBaseLogo
  }
}
</script>

<style scoped>
a:hover {
  text-decoration: underline;
}
</style>
